import { TaxStatus } from '@lucidlink/dto/validation';
export const BILLING_ADDRESS_US_RETURN = {
    city: 'Mock City',
    country: 'US',
    line1: '123 Mock Street',
    line2: 'Suite 100',
    state: 'CA',
};
export const BILLING_ADDRESS_US = {
    ...BILLING_ADDRESS_US_RETURN,
    postal_code: '12345',
};
export const TAX_INFO_WITH_ID = {
    taxStatus: TaxStatus.TAXABLE,
    taxId: 'MOCK-TAX-123',
};
export const TAX_INFO_US = {
    taxStatus: TaxStatus.TAXABLE,
};
export const INVALID_STRIPE_TOKEN = 'invalid_token';
export const TEST_STRIPE_TOKEN = 'tok_visa';
export const USER_NAME = 'Mock Customer';
export const CARD_DETAILS = {
    brand: 'visa',
    expiryMonth: 12, // month and year hardcoded in stripe mock - WebService/src/billing/stripe/stripe.service.mock.ts
    expiryYear: new Date().getFullYear() + 1,
    numberLast4: '4242',
};
export const INVALID_CARD_DETAILS = {
    expiryMonth: -5,
    expiryYear: 2000,
    numberLast4: '',
};
export const BILLING_SUBSCRIPTION_ID_STARTER = 1;
export const BILLING_SUBSCRIPTION_ID_BUSINESS = 2;
export const BILLING_SUBSCRIPTION_ID_BUSINESS_ANNUAL = 4;
export const BILLING_SUBSCRIPTION_ID_INVALID = 423423;
